var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMypicks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M230.8,240.8H40.4C18.1,240.8,0,258.9,0,281.2v190.5C0,493.9,18.1,512,40.4,512h190.5c22.3,0,40.4-18.1,40.4-40.4v-190.5c0-22.3-18.1-40.4-40.4-40.4ZM220.8,336.5l-101.1,101.1c-5.8,5.9-15.3,5.9-21.2,0l-48.1-48.1c-5.9-5.9-5.9-15.4,0-21.2,5.9-5.9,15.4-5.9,21.2,0l37.5,37.5,90.4-90.5c5.9-5.9,15.4-5.9,21.2,0,5.9,5.9,5.9,15.4,0,21.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.8,159.9v191.9c0,21.9-17.8,39.6-39.6,39.6h-50.9v-110.2c0-38.8-31.6-70.4-70.4-70.4h-110.2v-50.9c0-21.9,17.8-39.6,39.6-39.6h191.9c21.9,0,39.6,17.8,39.6,39.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512,39.6v191.9c0,21.9-17.8,39.6-39.6,39.6h-50.6v-111.3c0-38.4-31.3-69.7-69.7-69.7h-111.3v-50.6C240.8,17.8,258.6,0,280.5,0h191.9C494.2,0,512,17.8,512,39.6Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMypicks);
export default __webpack_public_path__ + "static/media/MYPICKS.6fec6118da61fc361a055d787346a7ec.svg";
export { ForwardRef as ReactComponent };